var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x37_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x38_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x39_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78,83.8H22c-3.7,0-7-1.9-8.8-5.1c-1.8-3.2-1.8-7,0-10.2l28-48.5C43,16.9,46.3,15,50,15s7,1.9,8.8,5.1l28,48.5   c1.8,3.2,1.8,7,0,10.2C85,81.9,81.7,83.8,78,83.8z M50,18c-2.6,0-4.9,1.3-6.2,3.6l-28,48.5c-1.3,2.2-1.3,4.9,0,7.2   c1.3,2.2,3.6,3.6,6.2,3.6h56c2.6,0,4.9-1.3,6.2-3.6c1.3-2.2,1.3-4.9,0-7.2l-28-48.5C54.9,19.3,52.6,18,50,18z M69.2,83.8H30.8   c-0.8,0-1.5-0.7-1.5-1.5V71c0-4.2,3.4-7.7,7.7-7.7h26c4.2,0,7.7,3.4,7.7,7.7v11.3C70.7,83.1,70,83.8,69.2,83.8z M32.3,80.8h35.3V71   c0-2.6-2.1-4.7-4.7-4.7H37c-2.6,0-4.7,2.1-4.7,4.7V80.8z M50,42c-2.7,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S52.7,42,50,42z M50,35   c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S51.1,35,50,35z M40,54c-2.7,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S42.7,54,40,54z M40,47   c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S41.1,47,40,47z M60,54c-2.7,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S62.7,54,60,54z M60,47   c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S61.1,47,60,47z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.3b68b0c56866935773392a5179717001.svg";
export { ForwardRef as ReactComponent };